export default function PollButtonDirective() {
  return {
    restrict: 'E',
    template: require('./equipment-polling.html'),
    scope: {},
    bindToController: {},
    controllerAs: "vm",
    controller: PollController
  };

  function PollController(usersService, EquipmentService, $stateParams, CommandsRepo) {
    'ngInject';
    var vm = this;

    // Public Variables
    vm.canPoll = false;
    vm.pollEquipmentData = pollEquipmentData;
    vm.buttonTitle = "Send Poll command to get recent data";

    // Init
    init();

    function init() {
      checkCanPoll();
    }

    // Public Functions
    function pollEquipmentData() {
      CommandsRepo.executeCommand($stateParams.equipmentId, "poll");
    }

    // Private Functions
    function checkCanPoll() {
      vm.canPoll = false;
      EquipmentService
        .getEquipment($stateParams.equipmentId, null, ["deviceCommands"])
        .then(function (response) {

          // Check for commands first
          if (!response.data.data.relationships.deviceCommands) {
            return;
          }

          // Check requirements.
          if (!usersService.hasRequiredFeatures(['commands.query']) || !_.find(response.data.data.relationships.deviceCommands.data, {
              id: "poll"
            })) {
            return;
          }
          vm.canPoll = true;
        })
        .catch(function () {
          vm.canPoll = false;
        });
    }
  }
}